/**
 * Utility functions for managing the application's authentication token in localStorage.
 * This module provides methods to get, set, and remove the token used for user authentication.
 */

/**
 * Retrieves the authentication token from localStorage.
 * @returns {string|null} The stored token, or null if not found.
 */

/**
 * Stores the authentication token in localStorage.
 * @param {string} token - The authentication token to store.
 */

/**
 * Removes the authentication token from localStorage.
 */
const TOKEN_KEY = 'access_token';
const USER_KEY = 'app_user'
const FCM_KEY = 'fcm_token';
const EXPIRY_KEY = 'token_expiry';


export const getToken = () => {
  return localStorage.getItem(TOKEN_KEY);
};

export const setToken = (token) => {
  localStorage.setItem(TOKEN_KEY, token);
};

export const removeToken = () => {
  localStorage.removeItem(TOKEN_KEY);
  localStorage.removeItem(EXPIRY_KEY);
};

export const setExpiry = (expiresInSeconds) => {
  if (!expiresInSeconds) return;
  // Store as timestamp (milliseconds)
  const expiryTime = Date.now() + expiresInSeconds * 1000;
  localStorage.setItem(EXPIRY_KEY, expiryTime.toString());
};

export const getExpiry = () => {
  const expiry = localStorage.getItem(EXPIRY_KEY);
  return expiry ? parseInt(expiry, 10) : null;
};

export const isTokenExpired = () => {
  const expiry = getExpiry();
  if (!expiry) return false; // If no expiry is set, we don't force logout proactive (fall back to 401)

  // Add a 60-second buffer to prevent race conditions
  const bufferTime = 60 * 1000;
  return Date.now() > (expiry - bufferTime);
};

export const setUser = (user) => {
  localStorage.setItem(USER_KEY, JSON.stringify(user));
};

export const getUser = () => {
  const user = localStorage.getItem(USER_KEY);
  return user ? JSON.parse(user) : null;
};

export const removeUser = () => {
  localStorage.removeItem(USER_KEY);
};

export const setFcmToken = (token) => {
  localStorage.setItem(FCM_KEY, token);
};

export const getFcmToken = () => {
  return localStorage.getItem(FCM_KEY);
};

export const removeFcmToken = () => {
  localStorage.removeItem(FCM_KEY);
  // console.log('Token Cleared')
};